import { render } from "./VacationEdit.vue?vue&type=template&id=4b50f2e2"
import script from "./VacationEdit.vue?vue&type=script&lang=js"
export * from "./VacationEdit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__